import type { GlobalThisWithLocalDevContext } from './GlobalThisWithLocalDevContext.tsx';

// oxlint-disable-next-line typescript/ban-ts-comment
// @ts-ignore - process.env types are cursed
const proxyServerPort = process.env.__PILLAR_PROXY_SERVER_PORT;
export default function getPillarProxyServerPort(): string | undefined {
	return (
		// oxlint-disable-next-line typescript/consistent-type-assertions
		(globalThis as GlobalThisWithLocalDevContext).localDevContext?.__PILLAR_PROXY_SERVER_PORT ??
		proxyServerPort
	);
}
